import { render, staticRenderFns } from "./PropertyCare.vue?vue&type=template&id=eab180d4&scoped=true&"
import script from "./PropertyCare.vue?vue&type=script&lang=ts&"
export * from "./PropertyCare.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eab180d4",
  null
  
)

export default component.exports